import React from 'react';

import { Checkbox, Stack, Text } from '@eluve/components';

interface OverrideSectionProps {
  label: string;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  children: React.ReactNode;
}

export const OverrideSection: React.FC<OverrideSectionProps> = ({
  label,
  enabled,
  onEnabledChange,
  children,
}) => {
  return (
    <Stack gap={2} className="rounded-lg border border-border-primary p-3">
      <Stack gap={2} align="center" direction="horizontal">
        <Checkbox
          checked={enabled}
          onCheckedChange={(checked) => onEnabledChange(checked === true)}
        />
        <Text size="md" inline>
          {label}
        </Text>
      </Stack>
      {enabled && (
        <Stack gap={2} className="pl-6">
          {children}
        </Stack>
      )}
    </Stack>
  );
};
